module.exports = __webpack_public_path__ + "static/media/88.11e074d.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/88.wav
// module id = wfpQ
// module chunks = 0